import { getI18n } from '@/plugins/i18n'
import { useLookup } from '@/composables/data-grid'
import { useDateColumn } from '@/composables/data-grid-column'
import { useRegistryStore } from '@/stores/registry.store'

export const useColumns = () => {
  const i18n = getI18n()
  const registryStore = useRegistryStore()
  const stockRangeRule = dataField => ({
    type: 'custom', reevaluate: true,
    message: i18n.t('error.validation.stock_range'),
    validationCallback: e => {
      const minimum = dataField === 'minimum_stock' ? e.value : e.data.minimum_stock
      const maximum = dataField === 'maximum_stock' ? e.value : e.data.maximum_stock
      return minimum == null || maximum == null || Number(minimum) <= Number(maximum)
    },
  })
  const quantityColumn = (dataField, label, allowEditing = false) => ({
    dataField, caption: i18n.t(`stockInfo.${label}`), dataType: 'number', width: '9rem',
    format: '#,##0.###', allowEditing,
    editorOptions: { readOnly: !allowEditing, format: '#,##0.###', ...(allowEditing ? { min: 0 } : {}) },
    validationRules: allowEditing ? [{ type: 'required' }, { type: 'range', min: 0 }, stockRangeRule(dataField)] : [],
  })

  return [
    {
      name: 'actions', type: 'buttons', buttons: [{ template: 'editButtonsTemplate' }], width: '6rem',
      visibleIndex: 0, fixed: true, fixedPosition: 'left', allowReordering: false, allowFixing: false,
    },
    {
      dataField: 'deposit', caption: i18n.t('common.deposit'), width: '14rem',
      lookup: useLookup({ store: registryStore.getLocalizedDeposits() }),
      validationRules: [{ type: 'required' }], sortOrder: 'asc',
    },
    quantityColumn('minimum_stock', 'minimumStock', true),
    quantityColumn('maximum_stock', 'maximumStock', true),
    {
      dataField: 'position', caption: i18n.t('stockInfo.position'), width: '12rem',
      editorOptions: { maxLength: 20 },
      validationRules: [{ type: 'stringLength', max: 20 }],
    },
    quantityColumn('stock', 'stock'),
    quantityColumn('ordered', 'ordered'),
    quantityColumn('customer_committed', 'customerCommitted'),
    quantityColumn('workshop_committed', 'workshopCommitted'),
    {
      ...quantityColumn('theoretical_stock', 'theoreticalStock'),
      calculateCellValue: row => row.stock ?? 0 + row.ordered ?? 0 - row.customer_committed ?? 0 - row.workshop_committed ?? 0,
      allowSorting: false, allowFiltering: false,
    },
    ...[['average_cost', 'averageCost'], ['weighted_average_cost', 'weightedAverageCost'], ['last_cost', 'lastCost']].map(([dataField, label]) => ({
      dataField, caption: i18n.t(`stockInfo.${label}`), dataType: 'number',
      format: '#,##0.000000', visible: false, showInColumnChooser: false, allowEditing: false,
      editorOptions: { readOnly: true, format: '#,##0.000000' },
    })),
    ...[['last_zero_stock_date', 'lastZeroStockDate'], ['last_movement_date', 'lastMovementDate']].map(([dataField, label]) => useDateColumn({
      dataField, caption: i18n.t(`stockInfo.${label}`), visible: false, showInColumnChooser: false, allowEditing: false,
      editorOptions: { readOnly: true },
    })),
  ]
}

